"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var Image_1 = require("../../../components/Image");
var string_1 = require("../../../../utils/string");
var styles = require("./index.scss");
var SingleSliding = (function (_super) {
    __extends(SingleSliding, _super);
    function SingleSliding() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            cIndex: 2,
            animationDuration: 0,
            dragPoints: null,
            wrapperOffsetLeft: 0,
            startTime: 0
        };
        _this.timeoutId = null;
        _this.windowScrollTimeoutId = 0;
        _this.isStop = false;
        _this.onTouchStart = function (e) {
            var animationDuration = _this.state.animationDuration;
            if (!_this.isDragging() && animationDuration === 0) {
                _this.stopAutoScroll();
                var touch = e.touches[0];
                var dragPoints = {
                    startPoint: {
                        x: touch.clientX,
                        y: touch.clientY
                    }
                };
                _this.setState({
                    dragPoints: dragPoints,
                    wrapperOffsetLeft: _this.scrollItemsWrapper.getBoundingClientRect().left,
                    startTime: new Date().getTime()
                });
            }
        };
        _this.onTouchMove = function (e) {
            if (_this.isDragging()) {
                var touch = e.touches[0];
                var endPoint = {
                    x: touch.clientX,
                    y: touch.clientY
                };
                var startPoint = _this.state.dragPoints.startPoint;
                if (Math.abs(endPoint.y - startPoint.y) > Math.abs(endPoint.x - startPoint.x)) {
                    _this.setState({ dragPoints: null });
                    _this.autoScroll();
                }
                else {
                    var dragPoints = Object.assign({}, _this.state.dragPoints, {
                        endPoint: endPoint
                    });
                    _this.setState({ dragPoints: dragPoints });
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        };
        _this.onTouchEnd = function (e) {
            var _a = _this.state, dragPoints = _a.dragPoints, containerWidth = _a.containerWidth, startTime = _a.startTime, cIndex = _a.cIndex;
            if (_this.isDragging()) {
                var updateState = {
                    dragPoints: null
                };
                if (typeof dragPoints.endPoint !== "undefined") {
                    var _b = _this.props, animationDuration = _b.animationDuration, swipeSensitive = _b.swipeSensitive, speedSensitive = _b.speedSensitive;
                    var distance = dragPoints.startPoint.x - dragPoints.endPoint.x;
                    var distanceAbs = Math.abs(distance);
                    var endTime = new Date().getTime();
                    var slideSpeed = (distanceAbs * 1000) / (endTime - startTime);
                    if (distanceAbs > Math.ceil((containerWidth * swipeSensitive) / 2) ||
                        slideSpeed > speedSensitive) {
                        var scrollNumber = Math.ceil(distanceAbs / containerWidth);
                        if (distance < 0) {
                            updateState.cIndex = cIndex - scrollNumber;
                        }
                        else {
                            updateState.cIndex = cIndex + scrollNumber;
                        }
                    }
                    if (updateState.cIndex < 0) {
                        updateState.cIndex = 0;
                    }
                    if (updateState.cIndex > _this.getNodeCount() - 1) {
                        updateState.cIndex = _this.getNodeCount() - 1;
                    }
                    var duration = Math.ceil((distanceAbs / containerWidth) * animationDuration);
                    updateState.animationDuration =
                        duration > animationDuration
                            ? animationDuration - (duration % animationDuration)
                            : duration < 50
                                ? 50
                                : duration;
                }
                _this.setState(updateState);
                _this.autoScroll();
            }
            if (dragPoints === null || typeof dragPoints.endPoint !== "undefined") {
                e.stopPropagation();
                e.preventDefault();
            }
        };
        _this.onTransitionEnd = function () {
            var moduleDetail = _this.props.moduleDetail;
            var cIndex = _this.state.cIndex;
            var updateState = {};
            if (cIndex > moduleDetail.module.elements.length + 1) {
                updateState.cIndex = 2;
            }
            else if (cIndex === 1) {
                updateState.cIndex = moduleDetail.module.elements.length + 1;
            }
            updateState.animationDuration = 0;
            _this.setState(updateState);
        };
        _this.renderCardBanner = function (img, href, index) {
            var width = _this.state.imgWidth / 16;
            var height = _this.state.imgHeight / 16;
            return (React.createElement("a", { href: string_1.isEmpty(href) ? undefined : href },
                React.createElement(Image_1.default, { className: styles.img, src: smartimagesrc_1.makeImageUrls(img, {
                        online: true,
                        qnParams: { w: _this.state.imgWidth },
                        keepSize: true
                    })[0], key: index, params: "imageView2/2/w/" + _this.state.imgWidth, style: {
                        width: width + "rem",
                        height: _this.state.cIndex === index ? height + "rem" : height * 0.9 + "rem",
                        opacity: _this.state.cIndex === index ? 1 : 0.6
                    }, useOriginSrc: true, alisize: 2, isLazyLoad: true })));
        };
        _this.bindContainerRef = function (me) {
            _this.container = me;
        };
        _this.bindScrollItemsWrapperRef = function (me) {
            _this.scrollItemsWrapper = me;
        };
        _this.onResize = function () {
            _this.setState({ containerWidth: _this.container.getBoundingClientRect().width });
        };
        _this.onWindowScroll = function () {
            clearTimeout(_this.windowScrollTimeoutId);
            _this.windowScrollTimeoutId = setTimeout(function () {
                if (_this.isContainerInCurrentScreen()) {
                    _this.isStop = false;
                }
                else {
                    _this.isStop = true;
                }
            }, 80);
        };
        return _this;
    }
    SingleSliding.prototype.getStyle = function () {
        var _a = this.state, cIndex = _a.cIndex, imgWidth = _a.imgWidth, animationDuration = _a.animationDuration, dragPoints = _a.dragPoints;
        var style = {};
        var offset = imgWidth === 280 ? 36 : 86;
        var wrapperOffsetLeft = -1 * cIndex * (imgWidth + 12) + offset;
        style.width = this.getNodeCount() + "00%";
        if (this.isDragging()) {
            var _b = dragPoints, endPoint = _b.endPoint, startPoint = _b.startPoint;
            var distance = typeof endPoint === "undefined" ? 0 : startPoint.x - endPoint.x;
            style.transform = "translate3d(" + (wrapperOffsetLeft - distance) / 16 + "rem,0,0)";
        }
        else {
            style.transform =
                cIndex === 0 ? "translate3d(0,0,0)" : "translate3d(" + wrapperOffsetLeft / 16 + "rem,0,0)";
            style.transitionDuration = animationDuration + "ms";
        }
        style.WebkitTransform = style.transform;
        style.transitionTimingFunction = "ease-out";
        return style;
    };
    SingleSliding.prototype.getNodeCount = function () {
        var moduleDetail = this.props.moduleDetail;
        return (moduleDetail.module && moduleDetail.module.elements && moduleDetail.module.elements.length + 4);
    };
    SingleSliding.prototype.isDragging = function () {
        return this.state.dragPoints !== null;
    };
    SingleSliding.prototype.render = function () {
        var _this = this;
        var _a = this.props, moduleDetail = _a.moduleDetail, id = _a.id;
        var elements;
        if (moduleDetail) {
            elements = moduleDetail.module.elements;
        }
        return (React.createElement("div", { id: id, className: styles.cardBannerContainer, ref: this.bindContainerRef, onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove, onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchEnd },
            React.createElement("div", { className: styles.scrollContainer, style: this.getStyle(), ref: this.bindScrollItemsWrapperRef, onTransitionEnd: this.onTransitionEnd },
                (elements || [])
                    .slice(-2)
                    .map(function (item, index) {
                    return _this.renderCardBanner(item.items[0].img, item.items[0].link, index);
                }),
                (elements || []).map(function (item, index) {
                    return _this.renderCardBanner(item.items[0].img, item.items[0].link, index + 2);
                }),
                (elements || [])
                    .slice(0, 2)
                    .map(function (item, index) {
                    return _this.renderCardBanner(item.items[0].img, item.items[0].link, index + 2 + elements.length);
                }))));
    };
    SingleSliding.prototype.autoScroll = function () {
        var _this = this;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(function () {
            if (!_this.isStop && document.visibilityState === "visible") {
                var cIndex = _this.state.cIndex;
                _this.scrollByIndex(cIndex + 1);
            }
            _this.autoScroll();
        }, 4000);
    };
    SingleSliding.prototype.scrollByIndex = function (index) {
        this.setState({
            cIndex: index,
            animationDuration: this.props.animationDuration
        });
    };
    SingleSliding.prototype.stopAutoScroll = function () {
        clearTimeout(this.timeoutId);
    };
    SingleSliding.prototype.componentDidMount = function () {
        this.setState({
            containerWidth: this.container.getBoundingClientRect().width,
            imgWidth: this.props.moduleDetail.layout.columnNum === 1 ? 280 : 180,
            imgHeight: this.props.moduleDetail.layout.columnNum === 1 ? 120 : 240
        });
        this.autoScroll();
        window.addEventListener("scroll", this.onWindowScroll);
        window.addEventListener("resize", this.onResize);
    };
    SingleSliding.prototype.componentWillUnmount = function () {
        this.stopAutoScroll();
        clearTimeout(this.windowScrollTimeoutId);
        window.removeEventListener("scroll", this.onWindowScroll);
        window.removeEventListener("resize", this.onResize);
    };
    SingleSliding.prototype.isContainerInCurrentScreen = function () {
        return this.container.getBoundingClientRect().bottom >= 0;
    };
    SingleSliding.defaultProps = {
        animationDuration: 200,
        swipeSensitive: 1,
        speedSensitive: 320
    };
    return SingleSliding;
}(React.Component));
exports.default = SingleSliding;
